'use client';

import Link from 'next/link';
import { BadgeCheck, Clapperboard, Dices, Gift, Store, Target, Ticket, TrendingUp, Trophy } from 'lucide-react';
import { Sites } from '@/types/enums';

const links = [
    {
        name: 'RAFFLES',
        href: '/raffles',
        icon: Ticket,
        description: 'Community raffles for Kick Points and Stake cash. Grab tickets with your Kick Points and watch the live draw.',
        meta: 'Win prize pools',
    },
    {
        name: 'GET STAKE ROLE',
        href: '/stake-role',
        icon: BadgeCheck,
        description: 'Play on Stake under code SOKOLOCO and get verified for 2x watch points, Kick chat giveaways and Stake-only raffles.',
        meta: 'Stake-only perks',
    },
    {
        name: 'BONUSES',
        href: '/bonuses',
        icon: Gift,
        description: 'Exclusive deposit offers and reload codes from every partner, with the exact steps to claim each one.',
        meta: 'Sign-up bonuses',
    },
    {
        name: 'LEADERBOARD',
        href: `/leaderboard/${Sites.STAKE}`,
        icon: Trophy,
        description: 'Live wager rankings with prize pools paid out at the end of every race. Track your place while the race runs.',
        meta: 'Wager races',
    },
    {
        name: 'CHALLENGES',
        href: '/challenges',
        icon: Target,
        description: 'Hit the target multiplier on a set slot and claim the bounty. New challenges go up throughout the stream.',
        meta: 'Slot challenges',
    },
    {
        name: 'STAKE LEVELS',
        href: '/stakelevels',
        icon: TrendingUp,
        description: 'Every rank and what it unlocks, plus the wager you need to reach it. No guessing how far the next tier is.',
        meta: 'Level-up rewards',
    },
    {
        name: 'SOKOPLAY',
        href: '/sokoplay',
        icon: Dices,
        description: 'Our own casino — slots, blackjack, roulette, crash and more, played with the points you earn on stream.',
        meta: 'Original games',
    },
    {
        name: 'STORE',
        href: '/store',
        icon: Store,
        description: 'Spend your Kick Points on digital and physical rewards — exclusive perks for the community.',
        meta: 'Redeem points',
    },
    {
        name: 'EARN',
        href: '/clips',
        icon: Clapperboard,
        description: 'Submit your best clips from the stream and get paid in Kick Points when they make the cut.',
        meta: 'Get paid for clips',
    },
];

export default function QuickLinks() {
    return (
        <div className="py-16 px-4">
            <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-4 text-green-400">
                <span className="inline-block animate-pulse">{'['}</span> QUICK LINKS <span className="inline-block animate-pulse">{']'}</span>
            </h2>
            <p className="text-center text-green-300 font-mono mb-12">
                Everything on the site, one tap away
            </p>

            <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {links.map(({ name, href, icon: Icon, description, meta }) => (
                    <Link
                        key={href}
                        href={href}
                        className="group relative backdrop-blur rounded-2xl overflow-hidden p-5 flex flex-col
                                   transition-all duration-300"
                    >
                        {/* Hover sweep, same accent the partner cards use */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/5 to-transparent
                                        opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                        <div className="relative flex items-start gap-4">
                            <div className="shrink-0 bg-green-500/10 rounded-lg p-2.5 text-green-400
                                            group-hover:bg-green-500/20 transition-colors duration-300">
                                <Icon size={20} />
                            </div>

                            <div className="min-w-0">
                                <div className="font-mono font-bold tracking-wider text-green-400">{name}</div>
                                <p className="mt-1 text-sm text-gray-400 leading-snug">{description}</p>
                            </div>
                        </div>

                        <div className="relative mt-auto pt-5 flex items-center gap-4">
                            <span className="flex-1 font-mono text-[11px] uppercase tracking-wider text-green-300/70">
                                {meta}
                            </span>

                            <span className="flex-1 relative text-center bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900
                                             rounded-xl shadow-lg group-hover:shadow-emerald-500/30 transition-all duration-200
                                             px-4 py-2 font-mono font-bold text-sm text-gray-200 overflow-hidden">
                                <span className="relative z-10">SEE MORE →</span>
                                <div className="absolute inset-0 bg-gradient-to-r from-green-400/0 via-green-400/30 to-green-400/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
